// Catalogo prodotti Magit: i dati sono in catalog.json (usato anche per la mappa del sito).
import catalog from "@/data/catalog.json";

export const PRODUCTS = catalog;

export const CATEGORIES = [...new Set(PRODUCTS.map((p) => p.category))];

export const productPath = (p) => `/shop/${p.slug}`;
